import { render, staticRenderFns } from "./CreateConfig.vue?vue&type=template&id=1b8f65d6&"
import script from "./CreateConfig.vue?vue&type=script&lang=js&"
export * from "./CreateConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports